// app/[locale]/corporativo/sigat/page.tsx
"use client";

import { useEffect, useState } from "react";
import LayoutBanner from "@/components/customLayoutServices/LayoutBanner";
import FlipCardSigat from "../components/FlipCardSigat";
import { fetchSigat } from "@/lib/api/datosGenerales/fetchSigat";
import { Sigat } from "@/lib/api/datosGenerales/types/sigat";
import { useTranslations, useLocale } from "next-intl";
import { type Locale } from "@/i18n/config";

export default function SigatPage() {
  const t = useTranslations("sigatPage");
  const locale = useLocale() as Locale;
  const [sigatData, setSigatData] = useState<Sigat[] | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadData() {
      try {
        const data = await fetchSigat(locale);
        setSigatData(data);
      } catch (error) {
        console.error("Error al cargar SIGAT:", error);
      } finally {
        setLoading(false);
      }
    }
    loadData();
  }, [locale]);

  if (loading) {
    return (
      <LayoutBanner
        bannerSrc="https://images.pexels.com/photos/4401167/pexels-photo-4401167.jpeg"
        cardTitle={t("titleCard")}
      >
        <div>
          <h2>{t("title")}</h2>
          <p>{t("text")}</p>
        </div>
      </LayoutBanner>
    );
  }
  if (!sigatData || sigatData.length === 0) {
    return (
      <LayoutBanner
        bannerSrc="https://images.pexels.com/photos/4401167/pexels-photo-4401167.jpeg"
        cardTitle={t("errorTitle")}
      >
        <div className="text-center max-w-xl mx-auto">
          <p>{t("errorMessage")}</p>
        </div>
      </LayoutBanner>
    );
  }

  return (
    <LayoutBanner
      bannerSrc="https://images.pexels.com/photos/4401167/pexels-photo-4401167.jpeg"
      cardTitle="SIGAT"
    >
      <div className="space-y-12">
        {sigatData?.map((item) => (
          <FlipCardSigat key={item.id} contenido={item.contenido} />
        ))}
      </div>
    </LayoutBanner>
  );
}
